import Axios from 'axios'
import urlSet from './url'
import { Message } from 'element-ui'

Axios.defaults.withCredentials = true // 允许跨域携带cookie

const request = Axios.create({
  baseURL: urlSet.baseUrl,
  timeout: 200000,
})
request.interceptors.request.use(
  (config) => {
    if (config.method == 'get') {
      //判断get请求
      config.params = config.params || {}
      config.params.t = Date.parse(new Date()) / 1000 //添加时间戳  防止接口缓存
    }
    if (localStorage.getItem('token')) {
      config.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use((res) => {
  if (res.status === 200 && res.data.cxajaxrc !== 0) {
    const message = res.data.cxajaxerrmsg
    console.log(message);
    if (message === '用户未登录' || message.includes('找不到ip') || message.includes('非IP范围内')) return false
    Message.error(message)
  }
  
  return res.data
})

export default request
